export default Object.freeze({
	startDate: "startDate",
	endDate: "endDate",
	custom: "custom",
	// todayYesterdayMonthLastMonth: "default",
	option1: "option1",
	option2: "option2",
	option3: "option3",
	option4: "option4",
	option5: "option5",

	cOption1: "cOption1",
	cOption2: "cOption2",
	cOption3: "cOption3",
	cOption4: "cOption4",
});
